import { useState } from 'react'

import Action from 'ageas-react-component-action'
import MiniLoader from 'ageas-react-component-miniloader'

import { Minus, Plus } from '../../Components/Icons'
import { ENV } from '../../Environment'
import { useContextStore } from '../../Stores/contextStore'
import { useDigitalSignatureSettingsStore } from '../../Stores/digitalSignature/useDigitalSignatureSettingsStore'
import { usePolicyholderDetailsStore } from '../../Stores/policyholderDetailsStore'
import { useAgent } from '../../Stores/useAgent'
import { useRefreshDigitalSignatureStatusStore } from '../../Stores/useRefreshDigitalSignatureStatusStore'
import { useSendDigitalSignatureStore } from '../../Stores/useSendDigitalSignatureStore'
import { useCancelDigitalSignatureProcess } from '../../hooks/api/useCancelDigitalSignatureProcess'
import { t } from '../../i18n'
import {
  ActionsCell,
  ActionsHeader,
  ButtonContainer,
  Cell,
  Header,
  IdCell,
  IdHeader,
  Row,
  Table,
  TableContainer,
  Title,
} from '../AnimalInsuranceTable/styles'
import { Expanded } from './Expanded'
import { DigitalSignaturesSelectionContainer } from './styles'

type Props = {
  isLoading: boolean
}

export const DigitalSignaturesSelection = ({ isLoading }: Props) => {
  const [expanded, setExpanded] = useState(true)
  const { policyholderDetailsSelected } = usePolicyholderDetailsStore()
  const { agentIdBySessionStorage } = useAgent()
  const { globalContext } = useContextStore()
  const { signatureTypeSelected } = useDigitalSignatureSettingsStore()
  const { sendDigitalSignature } = useSendDigitalSignatureStore()
  const { isSigned, isLoadingRefreshDigitalSignatureStatus } =
    useRefreshDigitalSignatureStatusStore()

  const { mutate, isLoading: isLoadingCancel } =
    useCancelDigitalSignatureProcess()

  const handleCancelDigitalSignature = () => {
    mutate({
      signatureId: sendDigitalSignature?.digitalSignature?.signatureId || '',
      user: globalContext?.username || '',
      mediationAccount: agentIdBySessionStorage || '',
      policyHolderFiscalNumber: policyholderDetailsSelected?.vatNumber || '',
      policyHolderId: policyholderDetailsSelected?.idEntity || '',
      accessType: 'S',
      branchCode: ENV().BranchCode, //TODO: Review
      applicationCode: ENV().ApplicationCode || '',
      originTemplate: '', //TODO: No data available, review
    })
  }

  return (
    <DigitalSignaturesSelectionContainer>
      <Title>{t('pages.step7.digitalSignatureList')}</Title>
      <TableContainer>
        <Table>
          <thead>
            <Row>
              <IdHeader></IdHeader>
              <Header>{t('table.name')}</Header>
              <Header>{t('pages.step7.signatureTypeUpper')}</Header>
              <Header>{t('pages.step7.signatureStatus')}</Header>
              <ActionsHeader></ActionsHeader>
            </Row>
          </thead>
          <tbody className="tbody">
            {isLoading && (
              <Row>
                <Cell colSpan={5}>
                  <MiniLoader color="white" minHeight="auto" maxWidth="auto" />
                </Cell>
              </Row>
            )}
            {!isLoading && (
              <Row>
                <IdCell />
                <Cell>
                  <div className="owner-data">{t('pages.step7.owner')}</div>
                  <label className="label">
                    {policyholderDetailsSelected?.name}
                  </label>
                </Cell>
                <Cell>
                  <label className="label">
                    {signatureTypeSelected?.signatureDescription}
                  </label>
                </Cell>
                <Cell>
                  {/* TODO: replace Pendente with signature status */}
                  <label className="label">Pendente</label>
                </Cell>
                <ActionsCell>
                  <ButtonContainer onClick={() => setExpanded((prev) => !prev)}>
                    {expanded ? (
                      <Minus color="#333" size={24} />
                    ) : (
                      <Plus color="#333" size={24} />
                    )}
                  </ButtonContainer>
                </ActionsCell>
              </Row>
            )}
            {expanded && !isLoading && (
              <Expanded
                entityPhone={
                  policyholderDetailsSelected?.phoneContactsList?.[0]
                    ?.contactNumber as string
                }
              />
            )}
          </tbody>
        </Table>
      </TableContainer>
      {!isSigned && sendDigitalSignature?.digitalSignature?.signatureId && (
        <div className="cancel-button">
          <Action
            id="button-signature-cancel"
            label={t('general.cancel')}
            buttonType="secondary"
            type="button"
            disable={isLoadingCancel || isLoadingRefreshDigitalSignatureStatus}
            onValueChanged={handleCancelDigitalSignature}
          />
        </div>
      )}
    </DigitalSignaturesSelectionContainer>
  )
}
